export default __webpack_public_path__ + "static/media/element_36.d6fa8d5e.webp";